<template>
  <div id="main">
    <h1>
      <transition
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated faster fadeOut"
      >
        <i class="fas fa-arrow-left" id="arrow" @click="back"></i> </transition
      >Svi tiketi
      <i class="fas fa-ticket-alt badge--mod"></i>
    </h1>
    <ticket-table></ticket-table>
  </div>
</template>

<script>
import TicketTable from '@/components/table/TableTickets.vue';
import { mapActions } from 'vuex';
export default {
  components: {
    TicketTable
  },
  created() {
    const params = this.$route.query;
    if (!Array.isArray(params.status) && params.status) {
      params.status = [params.status];
    }
    if (!Array.isArray(params.priority) && params.priority) {
      params.priority = [Number(params.priority)];
    }
    this.getAllTickets(params);
  },
  methods: {
    ...mapActions('table', ['getAllTickets']),
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
#main {
  padding: 0px 10px;
  padding-top: 30px;
}
h1 {
  text-align: center;
  padding-bottom: 40px;
  position: relative;
}
.badge--mod {
  position: absolute;
  right: 0;
  left: unset;
  border-radius: 50%;
  padding: 5px;
  margin-right: 10px;
}
</style>
